import * as React from 'react';
import { FormGroup, Input } from '../../../components/Bootstrap';
import { FufillmentCentersQuery_menus } from '../__generated__/FufillmentCentersQuery';
import { CenterModel } from '../types';

interface MenuSelectorProps {
  data: CenterModel;
  onChange(data: CenterModel);
  menus: FufillmentCentersQuery_menus[];
}

export const MenuSelector: React.FC<MenuSelectorProps> = ({ data, onChange, menus }) => {
  const onChangeSelect: React.ChangeEventHandler<HTMLSelectElement> = React.useCallback(
    (e) => {
      onChange({
        ...data,
        menuId: e.target.value,
      });
    },
    [onChange, data]
  );

  return (
    <FormGroup className='fulfillment-center-modal-input noble-custom-select'>
      <Input
        type='select'
        value={data.menuId}
        onChange={onChangeSelect}
        placeholder='E.g. 2nd floor bar'
        required={true}
      >
        {menus.map((menu) => (
          <option key={menu.id} value={menu.id}>
            {menu.name}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
};
